module.exports = __webpack_public_path__ + "static/media/scrap.3152ea6e.png";